module.exports = __webpack_public_path__ + "static/media/TUR.057c6929.jpg";